import React from "react";
import { Slider, Handles, Tracks, Ticks, Rail } from "react-compound-slider";

import "./style.scss";



// const Handle = ({ handle: { id, value, percent }, symbol, getHandleProps }) => (
//     <div style={{ left: `${percent}%` }} {...getHandleProps(id)}>
//     </div>
// )

const Handle = ({ handle: { id, value, percent }, symbol, isTheme, getHandleProps }) => (
    <div style={{ left: `${percent}%` }} {...getHandleProps(id)}>
        {isTheme ? null : <span>{value}<i>{symbol}</i></span>}
        <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="1.5" height="10" rx="0.75" fill="#6A3CE2"/>
            <rect x="4.5" width="1.5" height="10" rx="0.75" fill="#6A3CE2"/>
        </svg>
    </div>
)

const Track = ({ source: { percent }, target, getTrackProps }) => (
    <div style={{ left: `${percent}%`, width: `${target.percent - percent}%`}} {...getTrackProps()} />
)

const Tick = ({ tick: { percent, value }, count, symbol }) => (
    <div style={{marginLeft: `${-(100 / count) / 2}%`, width: `${100 / count}%`, left: `${percent}%`}}>
        {value + symbol}
    </div>
)


export default ({ domain, ticks, value, isTheme, step, receiveValue, suffix, className }) => {
    return (
        <div className={`react-compound-slider ${isTheme ? 'px-0 p-0' : ''} ${className}`}>
            <Slider
                rootStyle={{ position: "relative", width: isTheme ? "calc(100% - 3rem)" : "100%", height: isTheme ? "3rem" : "5rem", marginTop: "1rem" }}
                domain={domain}
                step={step || 1}
                mode={1}
                values={value}
                onChange={(value) => receiveValue(value[0])}
            >
                <Rail>
                    {({ getRailProps }) => <div className="react-compound-slider-rail" {...getRailProps()} />}
                </Rail>
                <Handles>
                    {({ handles, getHandleProps }) => (
                        <div className="react-compound-slider-handles">
                            {handles.map(handle => (
                                <Handle
                                    isTheme={isTheme}
                                    key={handle.id}
                                    handle={handle}
                                    symbol={suffix || ''}
                                    getHandleProps={getHandleProps}
                                />
                            ))}
                        </div>
                    )}
                </Handles>
                <Tracks right={false}>
                    {({ tracks, getTrackProps }) => (
                        <div className="react-compound-slider-tracks">
                            {tracks.map(({ id, source, target }) => (
                                <Track
                                    key={id}
                                    source={source}
                                    target={target}
                                    getTrackProps={getTrackProps}
                                />
                            ))}
                        </div>
                    )}
                </Tracks>
                {isTheme ? <div className="react-compound-slider-right-value">{`${value}${suffix}`}</div> : null}
                {ticks ? <Ticks values={ticks}>
                    {({ ticks }) => (
                        <div className="react-compound-slider-ticks" >
                            {ticks.map(tick => <Tick key={tick.id} tick={tick} count={ticks.length} symbol={suffix || ''} />)}
                        </div>
                    )}
                </Ticks> : null}
            </Slider>
        </div>
    )
}
